import { AssetAmc, DocumentDto } from './asset-details.model';
export interface Asset {
  ppmDetails?: AssetPpmDetailDto[];
  tickets?: TicketDto[];
  scheduleActivity?: ScheduleActivityBaseDto[];
  amcDetails?: AssetAmc[];
  documents?: DocumentDto[];
  id: number;
  name: string;
  identifier: string;
  spaceName: string;
  level: string;
  description: string;
  category: string;
  subCategory: string;
  typeName: string;
  elementFamily: string;
  typeWorkset: string;
  externalIdentifier: string;
  manufacturer: any;
  model: any;
  cost: string;
  installationDate: Date;
  plans: string;
  critical: string;
  department: string;
  isBms: boolean;
  bmsCategory: string;
}

export interface AssetInfoDetails {
  id?: number;
  name?: string;
  identifier?: string;
  spaceName?: string;
  level?: string;
  description?: string;
  category?: string;
  subCategory?: string;
  typeName?: string;
  elementFamily?: string;
  typeWorkset?: string;
  externalIdentifier?: string;
  manufacturer?: string;
  model?: string;
  cost?: number;
  installationDate?: string;
  plans?: number;
  critical?: string;
  department?: string;
  isBms?: boolean;
  bmsCategory?: string;
}

export interface AssetPpmDetailDto {
  name?: string;
  startDateTime?: string;
  endDateTime?: string;
  frequency?: string;
  activityType?: string;
  ppmActivities?: AssetPpmActivityDto[];
}

export interface AssetPpmActivityDto {
  name?: string;
  isMeasurable?: boolean;
  defaultValue?: string;
  minValue?: string;
  maxValue?: string;
  frequency?: string;
  performedBy?: string;
  remarks?: string;
  recordedReading?: string;
  activityType?: string;
  skippedQr?: boolean;
  expectedTime?: string;
  facility?: string;
  measurableUnit?: string;
}

export interface TicketDto {
  identifier?: string;
  spaceName?: string;
  summary?: string;
  description?: string;
  created_on?: string;
  request?: string;
  priority?: string;
  severity?: string;
  status?: string;
  communication?: string;
  assigned_to?: string;
  remarks?: string;
  created_by?: string;
  number?: string;
  objectId: number;
  spaceUrn?: string;
  spaceObjectId: number;
  urn: string;
  floorId?: number;
  blockId: number;
  floorName: string;
  blockName: string;
  department: string;
  critical: string;
}

export interface ScheduleActivityBaseDto {
  expectedTime?: string;
  performedTime?: string;
  activityPlanName?: string;
  startDateTime?: string;
  endDateTime?: string;
  frequency?: string;
  facility?: string;
  equipment?: string;
  department?: string;
  activityType?: string;
  status?: number;
}
